/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForPolicy extends models.GovernanceConfigurationBase {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForPolicy.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForPolicy>): GovernanceConfigurationBaseForPolicy {
        let obj = Object.assign(new GovernanceConfigurationBaseForPolicy(), model);
        GovernanceConfigurationBaseForPolicy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForPolicy>): GovernanceConfigurationBaseForPolicy {
        if (!model) return null;
        return GovernanceConfigurationBaseForPolicy.newInstance(<GovernanceConfigurationBaseForPolicy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForPolicy) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForPolicy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForPolicy): boolean {
        if (models.GovernanceConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForPolicy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy Engine Preferences
     */
    engine_preferences: Array<models.PolicyEngineType>;

}
